<template>
  <div class="page" style="position: relative; overflow-y: auto">
    <div class="titleView">
      <el-row>
        <el-col :span="18">
          <div style="font-size: 16px; font-weight: bold; padding: 0 10px">
            调拨单验收
          </div>
        </el-col>
        <!-- <el-col :span="4" :offset="8">
					<el-button type="warning" size="small" @click="RefuseAll">全部拒收</el-button>
					<el-button type="warning" size="small" @click="acceptanceAll">全部验收</el-button>
				</el-col> -->
        <el-col :span="6">
          <el-button size="small" @click="$router.back()">返回</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="titleView">
      <div style="padding: 10px">
        <el-col :span="8">
          <span>调拨单号:&nbsp;{{ tabInfo && tabInfo.processNumber }}</span>
        </el-col>
        <el-col :span="8">
          <span
            >调拨时间:&nbsp;{{
              tabInfo.createOperationInfo &&
              tabInfo.createOperationInfo.operationTime
            }}</span
          >
        </el-col>
        <el-col :span="8">
          <span
            >来源门店:&nbsp;{{
              tabInfo.inShopInfo && tabInfo.inShopInfo.shopName
            }}</span
          >
        </el-col>
      </div>
      <el-row style="padding: 10px">
        <el-col :span="8">
          <div>
            调拨人:&nbsp;{{
              tabInfo.createOperationInfo &&
              tabInfo.createOperationInfo.userName
            }}
          </div>
        </el-col>
        <el-col :span="8">
          <div>状态:&nbsp;{{ tabInfo.state && tabInfo.state.name }}</div>
        </el-col>
        <el-col :span="8">
          <div>调拨备注:&nbsp;{{ tabInfo.remark }}</div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="detailsList" style="width: 100%">
      <el-table-column prop="no" label="编号" column-key="tab3key1">
        <template slot-scope="scope">
          {{ scope.row.assetsCode && scope.row.assetsCode }}
        </template>
      </el-table-column>
      <el-table-column label="名称" column-key="tab3key2">
        <template slot-scope="scope">
          {{ scope.row.assetsName }}
        </template>
      </el-table-column>
      <el-table-column label="规格" column-key="tab3key3">
        <template slot-scope="scope">
          <span>{{ scope.row.skuName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="调拨数量" column-key="tab3key4">
        <template slot-scope="scope">
          <span>{{ scope.row.count }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 全部拒收-->
    <el-dialog title="全部拒收" :visible.sync="dialogFormVisible">
      <div style="margin-bottom: 10px">请输入拒收原因&nbsp;&nbsp;</div>
      <el-input
        type="textarea"
        v-model="reason"
        placeholder="拒收原因不少于5个字"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      reason: "",
      tabInfo: {},
      dialogFormVisible: false,
      detailsList: [],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 获取详情
    getTableData() {
      let loading = this.$loading();
      let params = {
        processNumber: this.$route.query.id,
      };
      this.$http
        .get(process.env.VUE_APP_zichan + "/api/AssetsHandover/detail", params)
        .then((res) => {
          loading.close();
          console.log("详情", res);
          if (res.code == 0) {
            this.tabInfo = res.data;
            this.detailsList = res.data.assetsInfo;
          }
        });
    },
    // 全部拒收
    RefuseAll() {
      this.dialogFormVisible = true;
    },
    // 全部验收
    acceptanceAll() {
      this.$confirm("是否确认资产调拨验收, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "全部验收成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消全部验收",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;

  // 重复头部
  .titleView {
    // width: 98%;
    padding: 20px 0;
    padding-left: 10px;
    margin: 0 auto;
    font-size: 14px;
    color: #2a2a2a;
    background: #fff;
    border-radius: 6px;
  }
}
</style>
